import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const BorrowerList = lazy(() => import('../../container/borrower/facilitator-borrower/borrowerList'));
const BorrowerUpdate = lazy(() => import('../../container/borrower/facilitator-borrower/borrowerUpdate'));
const BorrowerDetails = lazy(
  () => import('../../container/borrower/facilitator-borrower/borrowerDetail/borrowerDetails'),
);

function Borrowers() {
  return (
    <Routes>
      <Route path="list" element={<BorrowerList />} />
      <Route path="update/:id" element={<BorrowerUpdate />} />
      <Route path="detail/:id" element={<BorrowerDetails />} />
    </Routes>
  );
}

export default Borrowers;
